// Melden-Button im Kopf (Bauplan Punkt 7): roter "Melden"-Button oeffnet einen Dialog mit
// Kommentar-Pflicht (POST /documents/:id/report). Ist das Dokument bereits gemeldet, zeigt der
// Kopf einen roten Badge; Admins sehen zusaetzlich "Meldung loesen" (POST /documents/:id/report/
// resolve). Formular-Pflicht (RULES): preventDefault + Validierung + Loading-Disable + Toast.

import React, { useState } from 'react';
import { Flag, ShieldCheck } from 'lucide-react';
import { btnDanger, btnGhost, inputCls, ConfirmDialog } from '../ui';
import { reportDocument, resolveReport } from '../../api';

const AbReportButton = ({ user, isDarkMode, t, documentId, reportedAt, isAdmin, showSuccess, showError, onChanged }) => {
  const [dialog, setDialog] = useState(null); // 'report' | 'resolve' | null
  const [comment, setComment] = useState('');
  const [busy, setBusy] = useState(false);

  const close = () => { setDialog(null); setComment(''); };

  const submit = async () => {
    if (!comment.trim()) { showError?.(t('abPdf.reportCommentRequired')); return; }
    setBusy(true);
    try {
      if (dialog === 'resolve') {
        await resolveReport(user, documentId, comment.trim());
        showSuccess?.(t('abPdf.reportResolvedMsg'));
      } else {
        await reportDocument(user, documentId, comment.trim());
        showSuccess?.(t('abPdf.reportSubmittedMsg'));
      }
      close();
      onChanged?.();
    } catch (e) {
      showError?.(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {reportedAt && isAdmin ? (
        <button type="button" className={btnGhost(isDarkMode)} onClick={() => setDialog('resolve')}>
          <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4" />{t('abPdf.reportResolveButton')}</span>
        </button>
      ) : (
        <button type="button" disabled={!!reportedAt} className={btnDanger(isDarkMode)} onClick={() => setDialog('report')}
          title={reportedAt ? t('abPdf.reportAlreadyReported') : undefined}>
          <span className="flex items-center gap-2">
            <Flag className="w-4 h-4" />{reportedAt ? t('abPdf.reportedBadge') : t('abPdf.reportButton')}
          </span>
        </button>
      )}

      {dialog && (
        <ConfirmDialog
          isDarkMode={isDarkMode} t={t} busy={busy} tone={dialog === 'resolve' ? 'primary' : 'danger'}
          title={dialog === 'resolve' ? t('abPdf.reportResolveDialogTitle') : t('abPdf.reportDialogTitle')}
          message={dialog === 'resolve' ? t('abPdf.reportResolveDialogMsg') : t('abPdf.reportDialogMsg')}
          confirmLabel={dialog === 'resolve' ? t('abPdf.reportResolveButton') : t('abPdf.reportButton')}
          onConfirm={() => { void submit(); }}
          onCancel={close}
        >
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder={t('abPdf.reportCommentPlaceholder')}
            rows={3}
            className={`${inputCls(isDarkMode)} w-full resize-none`}
          />
        </ConfirmDialog>
      )}
    </>
  );
};

export default AbReportButton;
